/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function AstravelisLegal() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="30vh"
        width="100%"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          mb: 4,
        }}
      />
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mt: 0,
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MKTypography variant="h2" mb={4}>
                Datenschutz­erklärung Astravelis
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h3" mb={2}>
                Hinweis zur verantwortlichen Stelle
              </MKTypography>
              <MKTypography variant="h4" color="text" mb={4}>
                Die verantwortliche Stelle für die Datenverarbeitung des spieles Astravelis ist:
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={0}>
                Lennart Krömer
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                lennartkr@web.de
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={1}>
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
                personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h4" mb={2}>
                2. Datenerhebung
              </MKTypography>
              <MKTypography variant="h4" mb={2}>
                Google Play Dienste
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Diese App nutzt Dienste von Google Play. Die Nutzung der Google Play Dienste erfolgt
                gemäß den Google Play-Nutzungsbedingungen
                (https://play.google.com/about/play-terms/). Durch die Nutzung dieser App stimmen
                Sie den Nutzungsbedingungen von Google Play zu. Google kann Informationen über die
                Nutzung der App sammeln, wie in der Google-Datenschutzerklärung beschrieben. Die App
                verwendet Google Play Games Services für Spielfunktionen wie Achievements und
                Leaderboards. Die Nutzung dieser Dienste unterliegt den Datenschutzrichtlinien von
                Google.
              </MKTypography>
              <MKTypography variant="h4" mb={2}>
                Keine weitere Datenerhebung
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Außer den oben genannten Google Play Diensten werden keine weiteren
                personenbezogenen Daten der Nutzer erhoben, gespeichert oder verarbeitet. Alle
                Spieldaten werden ausschließlich lokal auf dem Gerät des Nutzers gespeichert.
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h4" mb={2}>
                Urheberrecht
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Alle Inhalte der App Astravelis sind urheberrechtlich geschützt. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
                Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des Entwicklers.
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h4" mb={2}>
                Haftungsausschluss
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Die Nutzung der App Astravelis erfolgt auf eigene Gefahr. Der Entwickler übernimmt
                keine Haftung für Schäden, die durch die Nutzung der App entstehen können. Dies gilt
                insbesondere für Schäden an der Hardware oder Software des Nutzers, für
                Datenverluste oder sonstige materielle oder immaterielle Schäden. Der Entwickler
                bemüht sich um die Richtigkeit und Aktualität der bereitgestellten Informationen,
                übernimmt jedoch keine Gewähr für deren Vollständigkeit oder Eignung für bestimmte
                Verwendungszwecke.
              </MKTypography>
            </Grid>
            <Grid item xs={12}>
              <MKTypography variant="h4" mb={2}>
                Änderungen der Nutzungsbedingungen
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={4}>
                Der Entwickler behält sich das Recht vor, diese Nutzungsbedingungen jederzeit und
                ohne vorherige Ankündigung zu ändern. Die jeweils aktuelle Version der
                Nutzungsbedingungen ist in der App verfügbar. Durch die fortgesetzte Nutzung der App
                nach einer Änderung der Nutzungsbedingungen erklären Sie sich mit den Änderungen
                einverstanden.
              </MKTypography>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

export default AstravelisLegal;
